import type { PcrSubmission } from '../../../services/pcrService';

type Row = Pick<
  PcrSubmission,
  | 'report_id'
  | 'service_area_text'
  | 'community_text'
  | 'road_text'
  | 'report_type'
  | 'activity_type'
  | 'user_name'
  | 'user_email'
> &
  Pick<PcrSubmission, 'foreman_area_name'>;

function mapFromRow(row: Row): Record<string, string> {
  return {
    report_id: row.report_id || '',
    service_area: row.service_area_text || '',
    community: (row.foreman_area_name ?? row.community_text) || '',
    road_name: row.road_text || '',
    road: row.road_text || '',
    road_text: row.road_text || '',
    report_type: row.report_type || '',
    activity_type: row.activity_type || '',
    user_name: row.user_name || '',
    user_email: row.user_email || '',
  };
}

/** Match server-side `applyPcrReplyPlaceholders` for preview in the reply modal. */
export function applyPcrReplyPlaceholdersClient(template: string, row: Row): string {
  const map = mapFromRow(row);
  return template.replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, (_m, rawKey: string) => {
    const key = String(rawKey).toLowerCase();
    return map[key] ?? '';
  });
}

export function defaultPcrReplySubject(row: Row): string {
  const rid = (row.report_id || '').trim();
  const road = (row.road_text || '').trim();
  if (rid && road) return `Re: PCR ${rid} – ${road}`;
  if (rid) return `Re: PCR ${rid}`;
  return 'Re: Your public condition report';
}
